const Entity = {

    // FIELDS
    "entity_name": "Pangalan ng Entidad",
    "entity_short_name": "Maikling Pangalan ng Entidad",
    "search": "Maghanap",

    // PAGE HEADER
    "entity": "Entidad",

    // ERROR
    "error_entity_name": "Ilagay ang Pangalan ng Entidad",
    "error_entity_short_name": "Ilagay ang Maikling Pangalan",

    // TABLE HEADER
    "table_entity_name": "PANGALAN",
    "table_entity_short_name": "MAIKLING PANGALAN",

}

export default Entity;